import { render, staticRenderFns } from "./edit-config-dialog.vue?vue&type=template&id=1bfe84dc&scoped=true"
import script from "./edit-config-dialog.vue?vue&type=script&lang=js"
export * from "./edit-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-config-dialog.vue?vue&type=style&index=0&id=1bfe84dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe84dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bfe84dc')) {
      api.createRecord('1bfe84dc', component.options)
    } else {
      api.reload('1bfe84dc', component.options)
    }
    module.hot.accept("./edit-config-dialog.vue?vue&type=template&id=1bfe84dc&scoped=true", function () {
      api.rerender('1bfe84dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/overview/edit-config-dialog.vue"
export default component.exports